import React from "react";
import _ from "lodash";
import User from "./components/user";
import AffiliateModal from "./components/affiliateModal";
// import StatsLoader from "../../components/statsLoader";
import searchIcon from "./search.png";
import "./styles.css";

export default class Users extends React.Component {
  state = {
    affiliatesFilter: false,
    searchBy: "email",
    searchQuery: "",
    users: [],
    totalPages: 0,
    currentPage: 1,
    searching: false,
    triggerLogsModalOpen: false,
    triggerLogsData: [],
    modalOpen: false,
    modalYesAction: null,
    modalYesClicked: false,
    concernedEmail: null,
    affiliateModalOpen: false,
    affiliateInfo: null,
    totalUsers: null,
    freeUsers: null,
    premiumUsers: null,
    allMails: null,
    freeMails: null,
    premiumMails: null,
  };

  componentDidMount() {
    //this.getUserStats();
    this.controller = new window.AbortController();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.searchQuery !== this.state.searchQuery &&
        this.state.searchQuery !== "") ||
      (prevState.searchBy !== this.state.searchBy &&
        this.state.searchQuery !== "") ||
      (prevState.affiliatesFilter !== this.state.affiliatesFilter &&
        this.state.searchQuery !== "") ||
      (!prevState.affiliatesFilter && this.state.affiliatesFilter)
    ) {
      this.controller.abort();
      this.controller = new window.AbortController();
      this.setState({ totalPages: 0, currentPage: 1, users: [] });
      this.debouncedSearch();
    } else if (
      prevState.currentPage !== this.state.currentPage &&
      this.state.totalPages !== 0
    ) {
      this.debouncedSearch();
    } else if (prevState.searchQuery !== "" && this.state.searchQuery === "") {
      this.controller.abort();
      this.controller = new window.AbortController();
      this.setState({
        users: [],
        totalPages: 0,
        currentPage: 1,
        searching: false,
      });
    }
  }

  getUserStats = () => {
    fetch(
      `https://us-central1-project-1029735015520686877.cloudfunctions.net/usersOverview?token=${this.props.idToken}`,

      {
        method: "POST",
        mode: "cors",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const users = [];
        const freeMails = [];
        const premiumMails = [];
        // eslint-disable-next-line guard-for-in
        for (let i in data) {
          users.push(data[i]);
        }
        const totalUsers = users.length;
        let premiumUsers = 0;
        let freeUsers = 0;
        for (let userObject of users) {
          if (userObject.info) {
            if (userObject.premium === "true") {
              premiumUsers++;
              premiumMails.push(userObject.info.email);
            } else {
              freeUsers++;
              freeMails.push(userObject.info.email);
            }
          }
        }

        const allMails = [...freeMails, ...premiumMails];

        this.setState({
          totalUsers,
          freeUsers,
          premiumUsers,
          allMails: JSON.stringify(allMails.filter((mail) => mail !== null)),
          freeMails: JSON.stringify(freeMails.filter((mail) => mail !== null)),
          premiumMails: JSON.stringify(
            premiumMails.filter((mail) => mail !== null)
          ),
        });
      });
  };

  copyEmails = (users) => {
    const { allMails, freeMails, premiumMails } = this.state;
    switch (users) {
      case "all":
        navigator.clipboard.writeText(allMails);
        break;
      case "free":
        navigator.clipboard.writeText(freeMails);
        break;
      case "premium":
        navigator.clipboard.writeText(premiumMails);
        break;
      default:
        break;
    }
  };

  handleTriggerLogsModal = (status, data) => {
    if (status === "open") {
      this.setState({
        triggerLogsModalOpen: true,
        triggerLogsData: data,
      });
    } else {
      this.setState({
        triggerLogsModalOpen: false,
        triggerLogsData: [],
      });
    }
  };

  handleModal = (status, action, concernedEmail) => {
    if (status === "open") {
      this.setState({
        modalOpen: true,
        modalYesAction: action,
        concernedEmail,
      });
    } else if (status === "close") {
      this.setState({
        modalOpen: false,
        modalYesAction: null,
        modalYesClicked: false,
        concernedUID: null,
      });
    }
  };

  determineModalText = () => {
    const email = this.state.concernedEmail;
    switch (this.state.modalYesAction) {
      case "setfree":
        return `Are you sure you want to set the user's account with email "${email}" to Free?`;
      case "setpremium":
        return `Are you sure you want to set the user's account with email "${email}" to Premium?`;
      case "setcyclone":
        return `Are you sure you want to set the user's account with email "${email}" to Premium + Cyclone?`;
      case "setaffiliate":
        return `Are you sure you want to make the user with email "${email}" an Affiliate Partner?`;
      case "unsetaffiliate":
        return `Are you sure you want to terminate the Affiliate Partnership of the user with email "${email}"?`;
      case "resetmachineid":
        return `Are you sure you want to reset the Machine ID of the user with email "${email}"?`;
      case "redflag":
        return `Are you sure you want to red flag the user with email "${email}"?`;
      case "redflagundo":
        return `Are you sure you want to undo red flag of the user with email "${email}"?`;
      default:
        break;
    }
  };

  uniqueIPs = () => {
    const logs = this.state.triggerLogsData;
    const uniqueIPs = [];
    const data = [];

    for (let i of logs) {
      if (!uniqueIPs.includes(i.ip)) {
        uniqueIPs.push(i.ip);
        data.push(i);
      }
    }
    return data
      .reduce(
        (a, b) => `${a}, ${b.ip} (${b.geo ? b.geo.country : "No Country"})`,
        ""
      )
      .slice(2);
  };

  search = () => {
    this.setState({ searching: true });
    const searchData = {
      searchBy: this.state.searchBy,
      searchQuery: this.state.searchQuery,
      idToken: this.props.idToken,
      page: this.state.currentPage,
      affiliatesFilter: this.state.affiliatesFilter,
    };

    fetch(
      //"http://localhost:5001/project-1029735015520686877/us-central1/adminSearchUsers",
      "https://us-central1-project-1029735015520686877.cloudfunctions.net/adminSearchUsers",
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(searchData),
        signal: this.controller.signal,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const arr = [];

        for (let i of data.users) {
          const user = {
            name: i.info.displayName,
            email: i.info.email,
            uid: i.info.uid,
            photoURL: i.info.photoURL,
            joined: i.info.joined,
            lastSignIn: i.info.lastSignIn,
            premium: i.premium === "true" ? true : false,
            cyclone: i.cyclone === "true" ? true : false,
            affiliate: i.affiliate,
            affiliatedBy: i.affiliatedBy,
            paypalMail: i.paypalPayment
              ? i.paypalPayment.payer.payer_info.email
              : null,
            triggerLogs: i.triggerLogs,
            redFlag: i.redFlag,
          };
          arr.push(user);
        }
        this.setState({ users: arr, totalPages: data.pages, searching: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ users: [], searching: false });
      });

    // axios
    //   .post(
    //     "https://us-central1-project-1029735015520686877.cloudfunctions.net/adminSearchUsers",
    //     searchData
    //   )
    //   .then(res => console.log(res))
    //   .catch(err => console.log(err));
  };

  debouncedSearch = _.debounce(this.search, 600);

  getPages = () => {
    if (this.state.totalPages === 0) return;

    const pages = [];
    for (let i = 1; i <= this.state.totalPages && i < 16; i++) {
      pages.push(i);
    }

    return (
      <div className="pages">
        {pages.map((pageNumber) => (
          <div
            key={pageNumber}
            className={
              pageNumber === this.state.currentPage
                ? "pagebox selected"
                : "pagebox"
            }
            onClick={() => this.setState({ currentPage: pageNumber })}
          >
            {pageNumber}
          </div>
        ))}
      </div>
    );
  };

  editAffiliateInfoModal = (affiliateInfo) =>
    this.setState({ affiliateModalOpen: true, affiliateInfo });

  closeAffiliateModal = () => this.setState({ affiliateModalOpen: false });

  render() {
    // const { totalUsers, freeUsers, premiumUsers } = this.state;
    return (
      <div className="users">
        <AffiliateModal
          idToken={this.props.idToken}
          modalOpen={this.state.affiliateModalOpen}
          closeModal={this.closeAffiliateModal}
          affiliateInfo={this.state.affiliateInfo}
          refresh={this.search}
        />
        <div
          className={
            this.state.triggerLogsModalOpen
              ? "modalwrapper open"
              : "modalwrapper"
          }
        >
          <div className="modal triggermodal">
            <div className="modalcontent">
              <p className="uniqueips">IPs: {this.uniqueIPs()}</p>
              <div className="logs">
                <div>
                  <table>
                    <tr>
                      <th>Date</th>
                      <th>HWID</th>
                      <th>IP</th>
                      <th>Country</th>
                      <th>Region</th>
                      <th>Zip</th>
                      <th>ISP</th>
                    </tr>
                    {this.state.triggerLogsData.map(
                      ({ date, mid, ip, geo }) => (
                        <tr>
                          <td>{date}</td>
                          <td>{mid}</td>
                          <td>{ip}</td>
                          <td>{geo ? geo.country : "No Country"}</td>
                          <td>{geo ? geo.region : "No Region"}</td>
                          <td>{geo ? geo.zip : "No Zip"}</td>
                          <td>{geo ? geo.isp : "No ISP"}</td>
                        </tr>
                      )
                    )}
                  </table>
                </div>
                {/*this.state.triggerLogsData.map(log => (
                  <div>
                    <h2>{log.date}</h2>
                    <div>
                      <p>IP Address: {log.ip}</p>
                      <p>Hardware ID: {log.mid}</p>
                    </div>
                  </div>
                ))*/}
              </div>
            </div>
            <div className="buttons">
              <button
                className="yesbtn"
                onClick={() => this.handleTriggerLogsModal("close")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
        <div
          className={
            this.state.modalOpen ? "modalwrapper open" : "modalwrapper"
          }
        >
          <div className="modal">
            <div className="modalcontent">
              <p>{this.determineModalText()}</p>
            </div>
            <div className="buttons">
              <button
                className="nobtn"
                onClick={() => this.handleModal("close")}
              >
                Cancel
              </button>
              <button
                className="yesbtn"
                onClick={() => this.setState({ modalYesClicked: true })}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
        {/* <div className="userstats">
          <div>
            <p className="stat  totalusers">Total Users</p>
            {totalUsers === null ? (
              <div className="statsloader">
                <StatsLoader />
              </div>
            ) : (
              <div className="num totalusers">
                <p>{totalUsers}</p>
                <button onClick={() => this.copyEmails("all")}>
                  Copy Emails
                </button>
              </div>
            )}
          </div>
          <div>
            <p className="stat freesers">Free Users</p>
            {freeUsers === null ? (
              <div className="statsloader">
                <StatsLoader />
              </div>
            ) : (
              <div className="num freeusers">
                <p>{freeUsers}</p>
                <button onClick={() => this.copyEmails("free")}>
                  Copy Emails
                </button>
              </div>
            )}
          </div>
          <div>
            <p className="stat premiumusers">Premium Users</p>{" "}
            {premiumUsers === null ? (
              <div className="statsloader">
                <StatsLoader />
              </div>
            ) : (
              <div className="num premiumusers">
                <p>{premiumUsers}</p>
                <button onClick={() => this.copyEmails("premium")}>
                  Copy Emails
                </button>
              </div>
            )}
          </div>
        </div> */}
        <div className="usersearch">
          <img src={searchIcon} alt="search icon" />
          <input
            // placeholder="Search Users"
            onChange={(e) => this.setState({ searchQuery: e.target.value })}
          />
          <select onChange={(e) => this.setState({ searchBy: e.target.value })}>
            <option value="email">Email</option>
            <option value="paypal">Paypal Mail</option>
            <option value="uid">UID</option>
            <option value="name">Name</option>
          </select>
        </div>
        <div className="filterswrap">
          <div className="filters">
            <h4>Filters</h4>
            <div
              className={
                this.state.affiliatesFilter
                  ? "filterbutton active"
                  : "filterbutton"
              }
              onClick={() =>
                this.setState(
                  (prevState) => ({
                    affiliatesFilter: prevState.affiliatesFilter ? false : true,
                  }),
                  () => {
                    //this.search();
                  }
                )
              }
            >
              Affiliates
            </div>
          </div>
        </div>
        {this.getPages()}
        <div className="userlist">
          {this.state.searching ? (
            <div className="loader" />
          ) : (
            this.state.users.map((user) => (
              <User
                key={user.uid}
                search={this.search}
                idToken={this.props.idToken}
                handleTriggerLogsModal={this.handleTriggerLogsModal}
                handleModal={this.handleModal}
                modalYesClicked={this.state.modalYesClicked}
                modalYesAction={this.state.modalYesAction}
                concernedEmail={this.state.concernedEmail}
                editAffiliateInfoModal={this.editAffiliateInfoModal}
                {...user}
              />
            ))
          )}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/pages/admin/sections/users/index.js
 **/